export enum LoginTranslations {
  title = 'login.title',
  description = 'login.description',
  createAccount = 'login.createAccount',
  login = 'login.login',
}
